import React from 'react'
import CV from "../assets/CV-rough.pdf"

const Footer = (props) => (
    <footer id="footer">
        <div className="inner">
            <ul className="icons">
                
                <li><a href={CV} className="icon alt fa-file"><span className="label">CV</span></a></li>
                <li><a href="https://bit.ly/2JHQxcN" className="icon alt fa-youtube"><span className="label">Youtube Playlist</span></a></li>
                <li><a href="https://github.com/JodyPSmith" className="icon alt fa-github"><span className="label">GitHub</span></a></li>
                <li><a href="https://www.linkedin.com/in/jodypsmith/" className="icon alt fa-linkedin"><span className="label">LinkedIn</span></a></li>
            </ul>
            <ul className="copyright">
                <li>&copy; Jody Smith 2018</li><li>Design: <a href="https://html5up.net">HTML5 UP</a></li>
            </ul>
        </div>
    </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js